import { Component, h, Event, EventEmitter, Prop, State } from '@stencil/core';
import { delay } from '../../../utils/utils';
import { BaseComponent } from '../../base-component';
import { FlowMoments, FlowSteps } from '../../../models/FlowSteps';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import store from '../../../helpers/store';
import { ApiCall } from '../../../helpers/ApiCall';
import { FlowStatus } from '../../../models/FlowStatus';

import logoOntrace from '../../../assets/logo-ontrace.svg';
import icoIdErr from '../../../assets/landing/ico-id-err.svg';
import icoFaceErr from '../../../assets/landing/ico-face-err.svg';
import icoInfo from '../../../assets/ico-info.svg';
import icoClose from '../../../assets/ico-close.svg';

@Component({
  tag: 'capture-error',
  styleUrl: 'capture-error.css',
  shadow: false,
})
export class CaptureError {
  @Prop() type: string;
  @Prop() reason: string;
  @Prop() error: string;

  @State() private modal: boolean;
  @State() private buttonEnabled: boolean;
  @State() private buttonText: string;
  private titleR1: string;
  private titleR2: string;
  private descriptionR1: string;
  private descriptionR2: string;
  private translations: TranslationValues;

  @Event({
    eventName: 'captureErrorDone',
  })
  eventCaptureErrorDone: EventEmitter;

  constructor() {}

  async componentWillLoad() {
    this.translations = await Translations.getValues();
    this.modal = false;
    this.buttonEnabled = false;
    if (this.type == 'ID') {
      if (this.reason == '') {
        this.titleR1 = this.translations.IdCaptureValues.ErrorTitleR1Blur;
        this.descriptionR1 = this.translations.IdCaptureValues.ErrorR1Blur;
      } else {
        this.titleR1 = this.translations.IdCaptureValues.ErrorTitleR1;
        this.descriptionR1 = this.translations.IdCaptureValues.ErrorR1;
      }
      this.titleR2 = this.translations.IdCaptureValues.ErrorTitleR2;
      this.descriptionR2 = this.translations.IdCaptureValues.ErrorR2;
    }
    if (this.type == 'LIVENESS') {
      this.titleR1 = this.translations.SelfieCaptureValues.ErrorTitleR1;
      this.titleR2 = this.translations.SelfieCaptureValues.ErrorTitleR2;
      this.descriptionR1 = this.translations.SelfieCaptureValues.ErrorR1;
      this.descriptionR2 = this.translations.SelfieCaptureValues.ErrorR2;
    }
  }

  async componentDidLoad() {
    await BaseComponent.logStep(FlowSteps.CiError, FlowMoments.Initialized);
    for (let i = 5; i >= 1; i--) {
      this.buttonText = i.toString();
      await delay(1000);
    }
    this.buttonText = this.translations.IdCaptureValues.Button;
    this.buttonEnabled = true;
  }

  async buttonClick() {
    this.buttonEnabled = false;
    await BaseComponent.logStep(FlowSteps.CiError, FlowMoments.Finalized);
    if (this.reason == 'Upload Failed') {
      var nextState = await ApiCall.instance.GetNextStateForCaptureError();
      store.flowStatus = nextState;
    } else if (this.reason == 'Invalid' && store.flowStatus == FlowStatus.IDBACK) {
      var nextState = await ApiCall.instance.GetNextStateForCaptureError();
      store.flowStatus = nextState;
    }
    this.eventCaptureErrorDone.emit();
  }

  async infoClick() {
    this.modal = true;
  }

  render() {
    return (
      <div class="container flex center">
        <div hidden={!this.modal} class="modal flex center w-100">
          <div class="inner w-100 text-center mx-1">
            <img class="close-modal" src={icoClose} onClick={() => (this.modal = false)}></img>
            <img src={icoInfo}></img>
            <h2 class="loud-text color-blue mb-1">
              <strong>{this.titleR2}</strong>
            </h2>
            <div class="color-blue checklist loud-text" innerHTML={this.descriptionR2}></div>
          </div>
        </div>

        <div class="px-3 text-center">
          <img class="mb-1 ml-1" src={this.type == 'ID' ? icoIdErr : icoFaceErr}></img>
          <h1 class="color-red mb-2" innerHTML={this.titleR1}></h1>
          <div class="color-blue mb-2 loud-text" innerHTML={this.descriptionR1}></div>

          <p class="flex center mb-3" onClick={() => this.infoClick()}>
            <strong class="color-blue loud-text">{this.translations.CameraErrorValues.Info}</strong> &nbsp;&nbsp;
            <img src={icoInfo}></img>
          </p>

          {store.debug ? <p class="font-size-1">{`${this.reason} ${this.error}`}</p> : null}

          <div class="button flex">
            <button class="main-button" type="button" disabled={!this.buttonEnabled} onClick={() => this.buttonClick()}>
              {this.buttonText}
            </button>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
